import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Typography,
  Box,
  Button,
  Skeleton
} from '@mui/material';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (!window.confirm("آیا مطمئنید؟")) return;

    const res = await fetch('/db/delete-project.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: project.id }),
    });

    const result = await res.json();

    if (result.status === 'success') {
      window.location.reload();
    } else {
      alert(result.message);
    }
  };

  return (
    <Paper
      onClick={() => navigate(`/project/${project.id}/dashboard/overview`)}
      sx={{
        p: 2,
        m: 1,
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: '#303B4B',
        color: 'white',
        borderRadius: '12px',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: { xs: 'none', md: 'scale(1.03)' },
          boxShadow: { xs: 'none', md: 'rgba(97, 218, 251, 0.3) 0px 0px 15px 2px' }
        },
        position: 'relative'
      }}
    >
      <Typography variant="h6" sx={{ fontFamily: 'system-ui', mb: 1, fontSize: '1rem' }}>
        {new URL(project.site_url).hostname}
      </Typography>

      <Typography variant="body2" sx={{ color: '#aaa', fontSize: '0.8rem' }}>
        ایجاد شده در {new Date(project.created_at).toLocaleDateString('fa-IR')}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Button
          size="small"
          variant="outlined"
          color="error"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handleDelete();
          }}
          sx={{
            fontSize: '0.75rem',
            borderColor: '#ff4d4d',
            color: '#ff4d4d',
            '&:hover': {
              backgroundColor: '#ff4d4d11',
              borderColor: '#cc0000',
              color: '#cc0000'
            }
          }}
        >
          حذف پروژه
        </Button>
      </Box>
    </Paper>
  );
};

export default ProjectCard;